import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePriceTradeType.module.scss'

import { TRADE } from '@Root/contants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  tradeType: TRADE
  setTradeType: (tradeType: TRADE) => void
}

const MyhousePriceTradeType: React.FC<Props> = ({ tradeType, setTradeType }: Props) => {
  return (
    <div className={cx('price_view_tab')} role="tablist">
      {/* [D] 버튼 클릭시 aria-selected를 true로 변경 */}
      <button
        type="button"
        className={cx('button_price_view')}
        aria-selected={tradeType === TRADE.DEAL}
        onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.DEAL, () => setTradeType(TRADE.DEAL))}
      >
        매매
      </button>
      <button
        type="button"
        className={cx('button_price_view')}
        aria-selected={tradeType === TRADE.LEASE}
        onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.LEASE, () => setTradeType(TRADE.LEASE))}
      >
        전세
      </button>
      <button
        type="button"
        className={cx('button_price_view')}
        aria-selected={tradeType === TRADE.RENT}
        onClick={handleNclickMix(NCLICK.MY_HOUSE.REAL_PRICE.RENT, () => setTradeType(TRADE.RENT))}
      >
        월세
      </button>
    </div>
  )
}

export default MyhousePriceTradeType
